import { getFlexicoTemplate } from "src/utilities/FlexicoAPIs";
import { ProcessTypeConfig } from "../Types/downloadAppModal";
import { getLogicoProcessById, getProcessById } from "../../Utils/AppActivityUtilsAppsyncPlus";

export const PROCESS_TYPE_CONFIG:ProcessTypeConfig = {
  flexico: {
    getProcessResponse: "getFlexicoTemplateRDS",
    getProcess: getFlexicoTemplate,
    processLabel: "label",
    processKey: "flex_id"
  },
  frisco: {
    getProcessResponse: "getProcessByIDV2RDS",
    getProcess: getProcessById,
    processLabel: "label",
    processKey: "process_id"
  },
  logico: {
    getProcessResponse: "getLogicoProcessByID",
    getProcess: getLogicoProcessById,
    processLabel: "display_label",
    processKey: "logico_process_id"
  }
}